export const getBadgeById = (state, badgeId) => state.badges.find(b => b.id === badgeId);
export const getAllBadges = state => state.badges;
